import { render, staticRenderFns } from "./CreatePlantVariety.vue?vue&type=template&id=28bdbacf&"
import script from "./CreatePlantVariety.vue?vue&type=script&lang=js&"
export * from "./CreatePlantVariety.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports